<template>
    <!--
        Tailwind UI | Form Layouts -> Labels On Left
        link: https://tailwindui.com/components/application-ui/forms/form-layouts
    -->
    <form class=" w-full m-4 py-2 px-4 rounded-md"
        @submit="formSubmit"
    >
        <div>
                <div class="mt-6 sm:mt-5">
                    <div v-if="permissions.can('edit_probe_serial')"
                            class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
                        <label for="probe_serial_number"
                               class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                            Probe Serial Number
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div class="max-w-xs rounded-md shadow-sm">
                                <input type="text"  v-if="permissions.can('edit_probe_serial')"
                                        id="probe_serial_number"
                                        v-model="probeSerial"
                                        class="block w-full sm:text-sm sm:leading-5"/>
                                <div v-else>{{ probeSerial }}</div>
                            </div>
                        </div>
                    </div>

                    <div v-if="permissions.can('edit_snap_enrollment')"
                            class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="snap_enrollment_status"
                               class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                            Snap Calibration Status
                        </label>
                        <div
                                class="mt-1 sm:mt-0 sm:col-span-2">
                          <span class="relative z-0 inline-flex shadow-sm rounded-md">
                            <button
                              type="button"
                              @click="snapEnrollStatus = false"
                              :class="!snapEnrollStatus ? 'bg-blue-200' : 'bg-white'"
                              class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                              No SNAP
                            </button>
                            <button
                              type="button"
                              @click="snapEnrollStatus = true"
                              :class="snapEnrollStatus ? 'bg-blue-200' : 'bg-white'"
                              class="-ml-px relative inline-flex items-center px-4 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-100 active:text-gray-700">
                              SNAP Enrolled
                            </button>
                          </span>
                        </div>
                    </div>
                    <div v-if="permissions.can('edit_device_address')"
                            class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="location" class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                            Location / Department
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
<!--                            TODO: Make sure the selected value gets selected-->
                            <div class="max-w-xs rounded-md shadow-sm">
                                <select id="location"
                                        v-model="departmentSelected"
                                        class="block w-full sm:text-sm sm:leading-5 js-single">
                                    <option  v-for="(department, id) in departmentsArray"
                                             :value="id">{{department}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
        </div>

        <error-message v-if="showError()">
            <p>
                Error Saving, please check that the probe serial is correct and try again.
            </p>
            <p>
                Contact Sonicu Support if you continue to have issues.
            </p>
        </error-message>

        <neutral-message v-if="showSaving()">
            Saving the Probe Information Please Wait.
        </neutral-message>

        <success-message v-if="showSuccess()">
            Successfully Saved the Probe Information.
        </success-message>

        <div class="mt-8 border-t border-gray-200 pt-5">
            <div class="flex justify-end">
            <span class="inline-flex rounded-md shadow-sm">
        <button type="button"
                @click="handleCancel"
                class="edit-cancel py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue-200 active:bg-gray-50 active:text-gray-800">
          Cancel
        </button>
      </span>
                <span class="ml-3 inline-flex rounded-md shadow-sm">
        <button v-if="canSave()" type="submit"
                class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:ring-blue-200 active:bg-blue-700">
          Save
        </button>
      </span>
            </div>
        </div>
    </form>
</template>

<script>

    let SAVE_STATE = {
        NOT_SAVED: 2,
        SAVING: 0,
        SAVED: 1,
        ERROR: -1,
    }

    import axios from 'axios';
    import SuccessMessage from "@/components/SuccessMessage";
    import NeutralMessage from "@/components/NeutralMessage";
    import ErrorMessage from "@/components/ErrorMessage";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

    export default {
        mixins: [SonicuCoreMixin],
        name: "CalibrationTablePartial",
        emits: ['save-success', 'cancel-edit'],
        components: {ErrorMessage, NeutralMessage, SuccessMessage},
        props: {
            device_id: {
                type: Number,
                default: 1,
            },
            serialNumber: {
                type: String,
                default: '',
            },
            snapEnroll: {
                type: Boolean,
                default: false,
            },
            departments: {
                type: Object,
                default: function() { return []; },
            },
            departmentSelect: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                saveState: SAVE_STATE.NOT_SAVED,
                deviceId: this.device_id,
                probeSerial: this.serialNumber,
                snapEnrollStatus: this.snapEnroll,
                departmentsArray: this.departments,
                departmentSelected: this.departmentSelect
                    ? this.departmentSelect
                    : '',
            }
        },
        mounted() {
            // $('.js-single').select2()
        },
        methods: {
            formSubmit(e) {
                e.preventDefault();
                this.saveState = SAVE_STATE.SAVING
                let context = this
                axios.post(this.company.buildCompanyApiInternalRoute('calibration-info/'), {
                    deviceId: this.deviceId,
                    probeSerial: this.probeSerial,
                    snapEnrollStatus: this.snapEnrollStatus,
                    department: this.departmentSelected === ''
                        ? null
                        : this.departmentSelected,
                })
                .then((response) => {
                    this.saveState = SAVE_STATE.SAVED
                    setTimeout(() => {
                        this.$emit('save-success', this.$data)
                    }, 1000)
                })
                .catch((error) => {
                    this.saveState = SAVE_STATE.ERROR
                });
            },
            handleCancel() {
                this.$emit('cancel-edit', this.deviceId)
            },
            showSuccess() {
                return this.saveState === SAVE_STATE.SAVED
            },
            showError() {
                return this.saveState === SAVE_STATE.ERROR
            },
            showSaving() {
                return this.saveState === SAVE_STATE.SAVING
            },
            canSave() {
                // If we have any of these permissions we can save
                return this.permissions.can('edit_probe_serial') ||
                        this.permissions.can('edit_snap_enrollment') ||
                        this.permissions.can('edit_device_address')
            },
        }
    }
</script>

<style scoped>

</style>